import React from 'react';

/**
 * Componente Card.
 * Un componente reutilizable que muestra una tarjeta con una imagen, un título y un contenido.
 * Está diseñado para ser usado en una cuadrícula, como en la sección "Propuesta de Valor".
 * 
 * @param {object} props - Las propiedades del componente.
 * @param {string} props.title - El título de la tarjeta.
 * @param {string} props.content - El texto o contenido principal de la tarjeta.
 * @param {string} props.imgSrc - La URL o ruta de la imagen a mostrar en la tarjeta.
 * @returns {JSX.Element} El elemento de la tarjeta renderizado.
 */
export const Card = ({ title, content, imgSrc }) => {
  return (
    // Contenedor principal de la tarjeta con estilos de fondo, padding, sombra y efectos de transición.
    <div 
      className="bg-blue-800 p-6 rounded-lg shadow-md text-white w-3/4 mx-auto transition duration-500 ease-in-out transform hover:scale-105 hover:shadow-lg" 
      style={{ boxShadow: '0 0 10px 6px rgba(0, 0, 0, 0.3)' }}
    >
      <div className="flex flex-col items-center">
        {/* Imagen de la tarjeta. */}
        <img src={imgSrc} alt={title} className="w-full h-25 object-cover mb-4 rounded-lg" />
        
        {/* Título de la tarjeta. */}
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
      </div>
      
      {/* Contenido de texto de la tarjeta. */}
      <p>{content}</p>
    </div>
  );
};

// Exporta el componente para su uso en otras partes de la aplicación.
export default Card;
